import axios, { AxiosResponse } from 'axios';
import { ChatbotData } from 'utils/helpers/chatbotHelpers';

export const getCompassQuestions = async (): Promise<ChatbotData> => {
  try {
    const response: AxiosResponse<ChatbotData> = await axios.get('/api/getCompassQuestions');
    return response.data;
  } catch (error) {
    console.error('Failed to fetch compass questions:', error);
    throw error;
  }
};
